import React, { useContext } from 'react';
import {
  TouchableOpacity,
  TextInput as RNTextInput,
  View,
  StyleSheet,
  GestureResponderEvent,
  TextInputProps,
} from 'react-native';
import { ThemeContext } from '..';

/*eslint-disable react-native/no-unused-styles*/
function getStyles(theme: Theme) {
  return StyleSheet.create({
    text: {
      fontFamily: theme.font.family,
      flex: 1,
    },
    inputContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    clearButton: {
      padding: 5,
      backgroundColor: 'rgb(155,155,155)',
      borderRadius: 15,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
}

export const TextInput = (props: Props) => {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);
  const { IconComponent } = theme;

  const { onClearText, style, value } = props;
  return (
    <View style={styles.inputContainer}>
      {<RNTextInput {...props} style={[styles.text, style]} value={value} />}
      {onClearText && !!value && (
        <TouchableOpacity style={styles.clearButton} onPress={onClearText}>
          <IconComponent name="cross" size={22} color="white" />
        </TouchableOpacity>
      )}
    </View>
  );
};

interface Props extends TextInputProps {
  onClearText?: (event: GestureResponderEvent) => void;
  style: any;
  value?: string;
}
